import { Paper, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * 快速操作组件的属性（预留扩展）
 */
export interface QuickActionsProps {
  // 可扩展的快速操作按钮属性
}

/**
 * 快速操作组件
 *
 * 显示在 Dashboard 中的快速操作区域，提供常用功能的快捷入口。
 *
 * @example
 * <QuickActions />
 */
export function QuickActions() {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3} sx={{ mt: 2 }}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            {t('dashboard.quickActions')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('dashboard.quickActionsDesc')}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
